exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".align-left{text-align:left}.align-right{text-align:right}.align-justify{text-align:justify}.align-center{text-align:center}.public-DraftEditorPlaceholder-root{position:absolute}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/_app/estimations/editor/tools/DraftComponent/styles.scss
// module id = 528
// module chunks = 1 2